import './ytBlankCard.scss'

export default {
    name: 'YtBlankCard',

    props: {
        noHeader: {
            type: Boolean,
            default: false
        },

        // 阴影属性 'always' | 'hover' | 'never'
        shadow: {
            type: String,
            default: 'always'
        }
    },

    render() {
        return (
            <el-card class='ytBlankCard' shadow={this.shadow}>
                {
                    !this.noHeader && (
                    <div class='blank-card_header' slot='header'>{this.$slots.header}</div>
                    )
                }

                {this.$slots.default}
            </el-card>
        )
    }
}